<template>
	<v-form ref="form" class="form" lazy-validation>
		<v-container>
			<v-text-field v-model.trim="setName" :rules="[rules.required]" class="mt-4" label="製品名(必須)" outlined dense></v-text-field>

			<v-row no-gutters>
				<v-col cols="12" lg="6" :class="$vuetify.breakpoint.lgAndUp ? 'pr-1' : ''">
					<v-select
						v-model="product.product_code_prefix_id"
						class="mt-4"
						required
						outlined
						dense
						:items="product.product_code_prefixes"
						item-text="name"
						item-value="id"
						@change="changeProductPrefix"
						label="品目コードの接頭辞を入力してください(必須)"
					>
					</v-select>
				</v-col>
				<v-col cols="12" lg="6" :class="$vuetify.breakpoint.lgAndUp ? 'pl-1' : ''">
					<v-text-field
						v-model.trim="setProductCode"
						class="mt-4"
						label="品目コード"
						outlined
						dense
						:persistent-hint="product.persistent_hint"
						hint="入力されない場合は自動で採番されます"
					/>
				</v-col>
			</v-row>

			<v-row no-gutters>
				<v-col cols="12" lg="6" :class="$vuetify.breakpoint.lgAndUp ? 'pr-1' : ''">
					<v-select
						v-model="product.product_category_id"
						class="mt-4"
						required
						outlined
						dense
						:items="product.categories"
						item-text="name"
						item-value="id"
						@change="setSubCategories"
						label="製品カテゴリーを選択してください(必須)"
					>
					</v-select>
				</v-col>

				<v-col cols="12" lg="6" :class="$vuetify.breakpoint.lgAndUp ? 'pl-1' : ''">
					<v-select
						v-model="product.product_sub_category_id"
						label="サブカテゴリーを選択してください(必須)"
						class="mt-4"
						outlined
						required
						dense
						:items="productSubCategories"
						item-text="name"
						item-value="id"
						no-data-text="先に製品カテゴリーを選択してください"
						@change="changeProduct"
					>
					</v-select>
				</v-col>
			</v-row>

			<v-text-field v-model.trim="setCostPrice" :rules="[rules.number]" class="mt-4" label="原価" outlined dense suffix="円" />

			<v-text-field v-model.trim="setStandardPrice" :rules="[rules.number]" class="mt-4" label="通常販売額" outlined dense suffix="円" />

			<v-text-field v-model.trim="setListPrice" :rules="[rules.number]" class="mt-4" label="定価" outlined dense suffix="円" />

			<v-textarea v-model="setSpecification" class="mt-4" label="製品仕様" outlined dense />

			<v-checkbox v-model="setWildcard" :true-value="false" :false-value="true" class="shrink ml-3" label="特定の仕様に限定する" dense />
		</v-container>

		<slot name="submit-btn"></slot>
	</v-form>
</template>

<script>
import rules from "../../helper/rules"

export default {
	props: {
		product: {
			type: Object,
			required: false,
			default: () => {},
		},
	},
	data() {
		return {
			rules,
			productSubCategories: [],
			product_category_id: "",
			product_sub_category_id: "",
		}
	},
	updated() {
		this.setSubCategoriesArray()
	},
	methods: {
		setSubCategories() {
			// サブカテゴリーの配列を作成し、選択された製品カテゴリーidを親へ渡す
			this.setSubCategoriesArray()
			this.product.product_sub_category_id = ""
			this.$emit("update:product_category_id", this.product.product_category_id)
		},
		changeProduct() {
			this.$emit("update:product_sub_category_id", this.product.product_sub_category_id)
		},
		changeProductPrefix() {
			this.$emit("update:product_code_prefix_id", this.product.product_code_prefix_id)
		},
		setSubCategoriesArray() {
			const category = this.product.categories.find((caregory) => caregory.id == this.product.product_category_id)
			if (category) {
				this.productSubCategories = category.product_sub_categories
			}
		},
	},
	computed: {
		setName: {
			get() {
				return this.product.name
			},
			set(newValue) {
				return this.$emit("update:name", newValue)
			},
		},
		setProductCode: {
			get() {
				return this.product.product_code
			},
			set(newValue) {
				return this.$emit("update:product_code", newValue)
			},
		},
		setCostPrice: {
			get() {
				return this.product.cost_price
			},
			set(newValue) {
				return this.$emit("update:cost_price", newValue)
			},
		},
		setStandardPrice: {
			get() {
				return this.product.standard_price
			},
			set(newValue) {
				return this.$emit("update:standard_price", newValue)
			},
		},
		setListPrice: {
			get() {
				return this.product.list_price
			},
			set(newValue) {
				return this.$emit("update:list_price", newValue)
			},
		},
		setSpecification: {
			get() {
				return this.product.specification
			},
			set(newValue) {
				return this.$emit("update:specification", newValue)
			},
		},
		setWildcard: {
			get() {
				return this.product.wildcard
			},
			set(newValue) {
				return this.$emit("update:wildcard", newValue)
			},
		},
	},
}
</script>

<style lang="scss" scoped>
.main-body {
	display: block !important;
	width: 70%;
	margin: 0 auto;
}
.product-new {
	.form {
		@media (min-width: 794px) {
			padding: 10px 57px;
		}

		&--center {
			text-align: center;
		}
	}
}
</style>
